import { IImageEvaluation } from '../types';
import ReactStars from "react-rating-stars-component";
import s from './imageEvaluationItemList.module.css';
import { Link } from "react-router-dom";
import { useState } from "react";

export default function ImageEvaluationItemList({ evaluation }: { evaluation: IImageEvaluation }) {
    const [isOpen, setIsOpen] = useState(false);

    const changeOpen = () => {
        setIsOpen(!isOpen);
    };

    const formatDate = (sendFeedbackDate: string) => {
        try {
            const date = new Date(sendFeedbackDate);
            return new Intl.DateTimeFormat('ru-RU', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }).format(date);
        } catch {
            return sendFeedbackDate;
        }
    };

    return (
        <div className={s.card}>
            <div className={s.header} onClick={changeOpen}>
                <div className={s.userInfo}>
                    <span className={s.userName}>{evaluation.userName}</span>
                    <span className={s.userEmail}>{evaluation.userEmail}</span>
                </div>
                <div className={s.date}>
                    {formatDate(evaluation.sendFeedbackDate)}
                </div>
                <div className={s.openIcon}>
                    {isOpen ? '▲' : '▼'}
                </div>
            </div>

            {isOpen && (
                <>
                    <div className={s.ratingSection}>
                        <div className={s.ratingHeading}>
                            <span className={s.ratingValue}>{evaluation.mark.toFixed(1)}</span>
                            <ReactStars
                                count={5}
                                value={evaluation.mark}
                                size={24}
                                color="#FFD700"
                                edit={false}
                            />
                        </div>

                        <div className={s.feedback}>
                            <div className={s.phrases}>
                                {evaluation.phrases.split(', ').map((phrase: string, i: number) => (
                                    <span key={i} className={s.phraseTag}>{phrase}</span>
                                ))}
                            </div>
                            {evaluation.review && (
                                <p className={s.review}>"{evaluation.review}"</p>
                            )}
                        </div>
                    </div>

                    <div className={s.outfitComposition}>
                        <h3 className={s.compositionTitle}>Состав образа</h3>
                        <div className={s.itemsGrid}>
                            {Object.entries(evaluation.fashionComposition).map(([key, item]: [string, any]) => (
                                item && (

                                    <div key={key} className={s.itemCard}>
                                        <Link
                                            key={`top-${key}`}
                                            to={`/details/${item.id}`}
                                            target="_blank"
                                        >
                                            <div className={s.itemImageContainer}>

                                                <img
                                                    src={item.thumbUrl || item.photoUrl}
                                                    className={s.itemImage}
                                                />
                                            </div>
                                        </Link>
                                        <div className={s.itemInfo}>
                                            <span className={s.itemName}>{item.name}</span>
                                            <span className={s.itemManufacturer}>{item.manufacturer}</span>
                                        </div>
                                    </div>
                                )
                            ))}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}